var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLiveIcon = function SvgLiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.747 4.2C3.451 4.2 2.4 5.185 2.4 6.4v8.8c0 1.215 1.051 2.2 2.347 2.2h14.507c1.296 0 2.346-.985 2.346-2.2V6.4c0-1.215-1.05-2.2-2.346-2.2H4.747z",
    fill: "url(#LiveIcon_svg__awhmmf30ga)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 9h.827v2.868H8.96v.732H6.6V9zm2.806 0h.828v3.6h-.828V9zm1.209 0h.944l.928 2.36h.011L13.442 9h.886l-1.549 3.6h-.663L10.615 9zm4.138 0h2.551v.732H15.58v.671h1.629v.733H15.58v.732h1.82v.732h-2.647V9z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.947 19.2c0-.331.287-.6.64-.6h6.827c.353 0 .64.269.64.6 0 .331-.287.6-.64.6H8.587c-.353 0-.64-.269-.64-.6z",
    fill: "url(#LiveIcon_svg__2lu88zuu5b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "LiveIcon_svg__awhmmf30ga",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.72228 10.26493 -13.07164 8.56033 5.278 7.135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "LiveIcon_svg__2lu88zuu5b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.8383 .93317 -.7693 2.33987 9.162 18.867)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgLiveIcon;